/*
 * @Description  :
 * @Author       : lcs
 * @Date         : 2023-12-22 00:44:11
 * @LastEditors  : luchaoshun@ihaier.com
 * @LastEditTime : 2023-12-28 21:11:38
 */
import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Public from './assets/js/public.js'
import filters from './assets/js/filters'
import request from './request/request'
import directives from './assets/js/directives'
import VueBus from 'vue-bus'
import VueQRCodeComponent from 'vue-qrcode-component'
import scroll from 'vue-seamless-scroll' // 无限滚动插件
import { drag, drags } from '@/directives/basic'
Vue.use(scroll)
// 加载二维码组件;
Vue.component('qr-code', VueQRCodeComponent)

Vue.config.productionTip = false
Vue.prototype.$Public = Public
Vue.prototype.httpGet = request.get
Vue.prototype.httpPost = request.post
Vue.prototype.httpUploadImg = request.upPic
Vue.use(ElementUI)
Vue.use(VueBus)
Vue.directive('drag', drag)
Vue.directive('drags', drags)
// 注册全局过滤器
Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]))

// 注册全局指令
Object.keys(directives).forEach((key) => Vue.directive(key, directives[key]))

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
